import {Templates, useTemplate} from "@/util-react/template.tsx";
import {LayoutStyleTypes} from "@/util-react/layout.tsx";
import React from "preact/compat";
import {CarBrandsListDefault} from "@/elements-react/car-brands-list/templates/car-brands-list.default.tsx";
import {CarBrandsListBlackAndBlue} from "@/elements-react/car-brands-list/templates/car-brands-list.black-and-blue.tsx";

export type CarBrandsListProps = {
    type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
};

const templates: Record<Templates, React.ComponentType<CarBrandsListProps>> = {
    [Templates.DEFAULT]: CarBrandsListDefault,
    [Templates.BLACK_AND_BLUE]:  CarBrandsListBlackAndBlue,
};

export const CarBrandsList = (props: CarBrandsListProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;
}